// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2JS-u","footer":"ModalCreateQualiphyProcedure_footer__2EyuD","additionData":"ModalCreateQualiphyProcedure_additionData__36aAk"};